import {
  db,
  docsFromSnapshot,
  docFromSnapshot,
  functions
} from "../../firebase";
import _ from "lodash";

export const DEFAULT_CREDIT_NOTE = {
  number: "CRN0001",
  invoiceNumber: null,
  sentDate: null,
  dueDate: "IMMEDIATELY",
  reason: "REFUND",
  from: {
    name: null,
    emailAddress: null,
    vatNumber: null,
    address: {
      line1: null,
      line2: null,
      district: null,
      region: null,
      country: null,
      postcode: null
    }
  },
  to: {
    companyName: null,
    emailAddress: null,
    vatNumber: null,
    address: {
      line1: null,
      line2: null,
      district: null,
      region: null,
      country: null,
      postcode: null
    }
  },
  items: [
    {
      description: null,
      price: null,
      quantity: "1",
      vat: null
    }
  ],
  subTotal: {
    amount: 0,
    displayValue: "€0.00"
  },
  vatTotal: {
    amount: 0,
    displayValue: "€0.00"
  },
  total: {
    amount: 0,
    displayValue: "€0.00"
  },
  refund: null,
  notes: null,
  deleted: false
};

const state = {
  creditNotes: {},
  creditNote: null,
  creditNoteNumberHistory: {
    nextNumber: "CRN0001",
    usedNumbers: []
  },
  creditNoteNumberPoller: null
};

const getters = {
  creditNotes: state => _.values(state.creditNotes),
  creditNotesCount: state => _.values(state.creditNotes).length | 0,
  creditNote: state => state.creditNote,
  nextCreditNoteNumber: state => state.creditNoteNumberHistory.nextNumber,
  creditNoteNumberPoller: state => state.creditNoteNumberPoller
};

const saveCreditNote = functions.httpsCallable("saveCreditNote");

const actions = {
  async fetchCreditNotes({ commit, getters }) {
    const snapshot = await db
      .collection("credit-notes")
      .where("tenantId", "==", getters.tenantId)
      .where("deleted", "==", false)
      .get();

    commit("setCreditNotes", docsFromSnapshot(snapshot));
  },
  async fetchCreditNote({ commit }, id) {
    commit("resetCreditNote");

    const snapshot = await db
      .collection("credit-notes")
      .doc(id)
      .get();

    const creditNote = docFromSnapshot(snapshot);
    if (creditNote) {
      commit("setCreditNote", creditNote);
    }
  },
  addCreditNote(context, creditNote) {
    creditNote = {
      ...creditNote,
      tenantId: context.getters.tenantId,
      timestamp: +new Date()
    };

    return saveCreditNote({ creditNote });
  },
  async fetchCreditNoteNumberHistory({ commit, getters }) {
    const tenantId = getters.tenantId;

    const snapshot = await db
      .collection("credit-note-number-history")
      .doc(tenantId)
      .get();

    const doc = docFromSnapshot(snapshot);

    if (doc) {
      commit("setCreditNoteNumberHistory", doc);
    }
  },
  startPollingCreditNoteNumberHistory(context) {
    context.dispatch("stopPollingCreditNoteNumberHistory");
    context.dispatch("fetchCreditNoteNumberHistory");

    const poller = setInterval(
      () => context.dispatch("fetchCreditNoteNumberHistory"),
      1000
    );

    context.commit("setCreditNoteNumberPoller", poller);
  },
  stopPollingCreditNoteNumberHistory(context) {
    const poller = context.getters.creditNoteNumberPoller;
    if (poller) {
      clearInterval(poller);
    }
    context.commit("setCreditNoteNumberPoller", null);
  }
};

const mutations = {
  setCreditNotes(state, creditNotes) {
    state.creditNotes = creditNotes;
  },
  setCreditNote(state, creditNote) {
    state.creditNote = creditNote;
  },
  resetCreditNote(state) {
    state.creditNote = null;
  },
  setCreditNoteNumberHistory(state, creditNoteNumberHistory) {
    state.creditNoteNumberHistory = creditNoteNumberHistory;
  },
  setCreditNoteNumberPoller(state, poller) {
    state.creditNoteNumberPoller = poller;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
